import { throttle } from 'lodash'

export default {
  data: () => {
    return {
      idleMixin_timer: null,
      idleMixin_isIdle: false,
      idleMixin_idleTimeout: 30 * 60000,
    }
  },
  computed: {
    /**
     * List of user events that reset the idle timer
     */
    idleMixin_idleBreakingEvents() {
      return ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart']
    },
  },
  async mounted() {
    this.idleMixin_idleTimeout = 30 * 60000
    this.idleMixin_isIdle = false
    await this.$nextTick()
    this.idleMixin_initIdleTimer()
  },
  methods: {
    idleMixin_initIdleTimer() {
      for (const event of this.idleMixin_idleBreakingEvents) {
        this.$el.addEventListener(event, this.idleMixin_resetTimer, true)
      }
    },
    idleMixin_resetTimer: throttle(async function() {
      this.idleMixin_isIdle = false
      if (this.idleMixin_timer) clearTimeout(this.idleMixin_timer)
      this.idleMixin_timer = setTimeout(
        () => this.idleMixin_handleIdleState(),
        this.idleMixin_idleTimeout
      )
    }, 200),
    idleMixin_handleIdleState() {
      this.idleMixin_isIdle = true
    },
    idleMixin_tearDown() {
      clearTimeout(this.idleMixin_timer)

      for (const event of this.idleMixin_idleBreakingEvents) {
        this.$el.removeEventListener(event, this.idleMixin_resetTimer)
      }
    },
  },
  beforeDestroy() {
    this.idleMixin_tearDown()
  },
}
